import { isEmpty, kebabCase } from 'lodash';
import { useIntl } from 'react-intl';

import { getReminderDefaultSendDate } from '../../data/data/utils';
import { ReminderFrequency } from '../../data/types/api/graphql';

export type ReminderDescriptionData = {
  startDate: string;
  frequency: ReminderFrequency;
  noEndDate: boolean;
  occurrence: number | null | undefined;
};

type ReminderDescriptionProps = {
  data: ReminderDescriptionData;
};

export function ReminderDescription({ data }: ReminderDescriptionProps) {
  const intl = useIntl();

  if (isEmpty(data.startDate)) return null;

  const date = getReminderDefaultSendDate(data.startDate);

  const values = {
    ...data,
    frequency: intl.formatMessage({
      id: `common.reminder-frequency.${kebabCase(data.frequency)}`,
    }),
    date: intl.formatDate(date, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }),
    time: intl.formatDate(date, {
      hour: 'numeric',
      minute: 'numeric',
    }),
  };

  if (data.frequency !== ReminderFrequency.Once) {
    if (!data.noEndDate) {
      return intl.formatMessage(
        {
          id: 'common.reminder-description.case-3',
        },
        values
      );
    }

    return intl.formatMessage(
      {
        id: 'common.reminder-description.case-2',
      },
      values
    );
  }

  return intl.formatMessage(
    {
      id: 'common.reminder-description.case-1',
    },
    values
  );
}
